global.jQuery = require('jquery');
global.$ = global.jQuery;

import * as core from '../libs/tech.core'
import * as lazyLoad from '../libs/tech.lazy-load'
import * as home from '../libs/tech.home'
import * as shared from '../libs/tech.shared'
import * as phone from '../libs/tech.phone'
import * as captchaV3 from '../libs/tech.captchaV3'

$(function () {
    lazyLoad.initLazyLoad('.lazyBackground');
    lazyLoad.initLazyLoad('.lazyFlag', false, 1100, function(){
        if (document.getElementsByTagName('html')[0].classList.contains('webp')) {
            $('.flag').css('background', 'url(/assets/img/flags-tech.webp) no-repeat');
        } else {
            $('.flag').css('background', 'url(/assets/img/flags-tech.jpg) no-repeat');
        }
    });
})

export { core, lazyLoad, home, shared, phone, captchaV3 }

//:not(.webp) .flag{background:url('/assets/img/flags-tech.jpg') no-repeat}.webp .flag{background:url('/assets/img/flags-tech.webp') no-repeat}